import formatCurrency from './format-currency';

const format = {
  currency: formatCurrency,
  percent: (amount: number | null | undefined, fractionDigits = 2) => {
    const defaultValue = amount ?? 0;
    return `${defaultValue.toFixed(fractionDigits).replace('.', ',')} %`;
  },
};

export default format;
